export function toggleAllSelection<T>(v: T[], compare: T[], allSelection: T) {
  if (v.includes(allSelection) && v.length > 1) {
    if (compare.includes(allSelection)) {
      return v.filter((s) => s !== allSelection);
    } else {
      return [allSelection];
    }
  } else {
    return v;
  }
}
